export enum ContentType {
  SHOWBOARD = 1,
  PROJECT = 2,
  IMAGE = 3,
  VIDEO = 4,
  PLAYLIST = 5,
  POWERPOINT = 6,
  WEBOBJECT = 7,
  MODULE = 8,
  WAYFINDING = 9,
  FILE = 10,
  FORM = 11
}

export const EVENT_MODULE_ID = '5258DE00-64EE-4F98-B8EE-11C0A042C003';
export const NULL_PARENT_FOLDER = '00000000-0000-0000-0000-000000000000';
